// COOKIE DELAY
(function () {
  var delay = 8000;

  function delayCookieBanner() {
    var banner = document.getElementById('shopify-pc__banner');

    if (banner) {
      // Hide it immediately
      banner.style.display = 'none';

      // Show it after 5 seconds
      setTimeout(function () {
        banner.style.display = 'block';
      }, delay);

      return true;
    }

    return false;
  }

  // Try immediately
  if (!delayCookieBanner()) {
    // Shopify may inject the banner after page load,
    // so watch for it being added to the DOM.
    var observer = new MutationObserver(function () {
      if (delayCookieBanner()) {
        observer.disconnect();
      }
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }
})();


//TABLE INDICATOR
document.addEventListener('DOMContentLoaded', function () {

  function initializeScrollableTables() {

    var elements = document.querySelectorAll(
      '.bundle-comparison-table,' +
      '.pr-tablewrap,' +
      '.tbl-wrap,' +
      '.articles__wrp table,' +
      '.articles__content table'
    );

    elements.forEach(function (element) {

      /* Prevent duplicate initialization */
      if (element.dataset.scrollInitialized === 'true') {
        return;
      }

      /* Already wrapped */
      if (
        element.parentElement &&
        element.parentElement.classList.contains(
          'bundle-comparison-scroll'
        )
      ) {
        element.dataset.scrollInitialized = 'true';
        return;
      }

      element.dataset.scrollInitialized = 'true';

      createScrollWrapper(element);

    });
  }


  function createScrollWrapper(target) {

    var wrapper = document.createElement('div');

    wrapper.className = 'bundle-comparison-scroll';


    /* Create indicator */
    var indicator = document.createElement('div');

    indicator.className = 'bundle-scroll-indicator';

    indicator.textContent = '← Swipe to scroll →';


    /* Insert wrapper */
    target.parentNode.insertBefore(wrapper, target);


    /* Move target into wrapper */
    wrapper.appendChild(indicator);
    wrapper.appendChild(target);


    /*
     * Check if the table actually overflows.
     */
    function checkScrollable() {

      if (wrapper.scrollWidth > wrapper.clientWidth + 5) {

        indicator.classList.remove('is-hidden');

      } else {

        indicator.classList.add('is-hidden');

      }

    }


    /*
     * Hide indicator after scrolling.
     */
    wrapper.addEventListener('scroll', function () {

      if (wrapper.scrollLeft > 5) {

        indicator.classList.add('is-hidden');

      } else {

        indicator.classList.remove('is-hidden');

      }

    });


    /* Initial check */
    checkScrollable();


    /* Check after images/fonts/layout finish */
    setTimeout(checkScrollable, 300);
    setTimeout(checkScrollable, 1000);


    window.addEventListener('resize', checkScrollable);

  }


  /*
   * Initial load
   */
  initializeScrollableTables();


  /*
   * Shopify/theme content can load dynamically.
   */
  var observer = new MutationObserver(function () {

    initializeScrollableTables();

  });


  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

});